<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="分组id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'groupId', validatorRules.groupId]" placeholder="请输入分组id"></a-input>
        </a-form-item>
        <a-form-item label="角色id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'roleId', validatorRules.roleId]" placeholder="请输入角色id"></a-input>
        </a-form-item>
        <a-form-item label="用户编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'userNo', validatorRules.userNo]" placeholder="请输入用户编号"></a-input>
        </a-form-item>
        <a-form-item label="用户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'userName', validatorRules.userName]" placeholder="请输入用户姓名"></a-input>
        </a-form-item>
        <a-form-item label="分配日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'workDay', validatorRules.workDay]" placeholder="请输入分配日期" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="基地编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'baseNo', validatorRules.baseNo]" placeholder="请输入基地编码"></a-input>
        </a-form-item>
        <a-form-item label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'base', validatorRules.base]" placeholder="请输入基地"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: "BusInspectionGroupUserConfigModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          groupId: {rules: [
          ]},
          roleId: {rules: [
          ]},
          userNo: {rules: [
          ]},
          userName: {rules: [
          ]},
          workDay: {rules: [
          ]},
          baseNo: {rules: [
          ]},
          base: {rules: [
          ]},
        },
        url: {
          add: "/group/busInspectionGroupUserConfig/add",
          edit: "/group/busInspectionGroupUserConfig/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'groupId','roleId','userNo','userName','workDay','baseNo','base'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'groupId','roleId','userNo','userName','workDay','baseNo','base'))
      },

      
    }
  }
</script>